export default __webpack_public_path__ + "static/media/AktivGroteskBlk.20462e19.ttf";